/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S2_R3_ChannelInputs */

const tr_kvkkbasvuru_s2_r3_channel = /** @type {(inputs: Kvkkbasvuru_S2_R3_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posta / Noter`)
};

const en_kvkkbasvuru_s2_r3_channel = /** @type {(inputs: Kvkkbasvuru_S2_R3_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post / Notary`)
};

const de_kvkkbasvuru_s2_r3_channel = /** @type {(inputs: Kvkkbasvuru_S2_R3_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post / Notar`)
};

const ru_kvkkbasvuru_s2_r3_channel = /** @type {(inputs: Kvkkbasvuru_S2_R3_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Почта / нотариус`)
};

/**
* | output |
* | --- |
* | "Post / Notary" |
*
* @param {Kvkkbasvuru_S2_R3_ChannelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s2_r3_channel = /** @type {((inputs?: Kvkkbasvuru_S2_R3_ChannelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S2_R3_ChannelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s2_r3_channel(inputs)
	if (locale === "de") return de_kvkkbasvuru_s2_r3_channel(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s2_r3_channel(inputs)
	return tr_kvkkbasvuru_s2_r3_channel(inputs)
});